import { useSelector } from 'react-redux';

import { DEFAULT_COUNTRY } from './useUserCountryRelatedInfo';
import { Country, Locale, Territory } from '../@types/country';
import { getUserCountry } from '../modules/user';

export const COUNTRY_LOCALE_TERRITORY_MAP: Record<
	Country,
	{ locale: Locale; territory: Territory }
> = {
	CZ: { locale: 'cs', territory: 'cs_CZ' },
	SK: { locale: 'sk', territory: 'sk_SK' },
	HU: { locale: 'hu', territory: 'hu_HU' },
};

const useInitialCountryLocale = (): { country: Country; locale: Locale; territory: Territory } => {
	const useCountry = useSelector(getUserCountry);
	const defaultWebCountry: Country | undefined = process.env.MOB_APP_BUILD
		? undefined
		: process.env.COUNTRY
			? (process.env.COUNTRY.toUpperCase() as Country)
			: undefined;

	const country = useCountry || defaultWebCountry || DEFAULT_COUNTRY;
	const { locale, territory } =
		COUNTRY_LOCALE_TERRITORY_MAP[country] || COUNTRY_LOCALE_TERRITORY_MAP.CZ;

	return {
		country,
		locale,
		territory,
	};
};

export default useInitialCountryLocale;
